module.exports = __webpack_public_path__ + "img/lecture_icon_white.b5dd97e9.svg";